var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { SportDataGatewayQueryInfo } from "sb-bff-integration";
import { deepMerge } from "sb-helpers";
import { observable, action } from "mobx";
import { createAggregatedEventsQueryString, createEventsQueryString, generateParticipantMapping } from "../../Helpers";
export class AggregatedEventsRetriever {
    constructor(data) {
        this.aggregatedEventId = -1;
        this.aggregatedEvents = [];
        this.events = [];
        this.gateway = data.gateway;
        this.langCode = data.languageCode;
        this.messageBus = data.messageBus;
        this.aggregatedEventsSubscription = undefined;
        this.eventsSubscription = undefined;
        this.updateAggregatedEventId = this.updateAggregatedEventId.bind(this);
        this.updateAggregatedEvents = this.updateAggregatedEvents.bind(this);
        this.updateEvents = this.updateEvents.bind(this);
        this.eventsQuery = new SportDataGatewayQueryInfo("", this.updateEvents);
        this.aggregatedEventsQuery = new SportDataGatewayQueryInfo("", this.updateAggregatedEvents);
        this.currentSelectedTimeZone = 0;
    }
    activate() {
        this.messageBus.on(InternalMessageBusChannels.legacy.timeZone.update, this.updateTimeZone);
        this.messageBus.on(InternalMessageBusChannels.aggregatedEvents.currentId.update, this.updateAggregatedEventId);
        this.requestAggregatedEventId();
        this.requestTimeZone();
    }
    deactivate() {
        this.messageBus.off(InternalMessageBusChannels.legacy.timeZone.update, this.updateTimeZone);
        this.messageBus.off(InternalMessageBusChannels.aggregatedEvents.currentId.update, this.updateAggregatedEventId);
        this.unsubscribe();
        this.aggregatedEvents = [];
        this.events = [];
    }
    requestTimeZone() {
        this.messageBus.emit(InternalMessageBusChannels.legacy.timeZone.request, { callback: this.setTimeZone });
    }
    requestAggregatedEventId() {
        this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.currentId.request, { requestCurrentAggregatedEventId: true });
    }
    setTimeZone(message) {
        this.currentSelectedTimeZone = message.currentSelectedTimeZone;
    }
    updateTimeZone(message) {
        this.currentSelectedTimeZone = message.data[0].currentSelectedTimeZone;
    }
    updateAggregatedEventId(message) {
        if (message.data[0] && message.data[0].currentAggregatedId > -1) {
            this.aggregatedEventId = message.data[0].currentAggregatedId;
            this.aggregatedEventsQuery.query = createAggregatedEventsQueryString(this.aggregatedEventId);
            this.aggregatedEventsQuery.locale = this.langCode;
            this.aggregatedEventsQuery.initialData = "true";
            this.subscribeForAggregatedEvents();
        }
    }
    subscribeForAggregatedEvents() {
        this.aggregatedEventsSubscription && this.aggregatedEventsSubscription.unsubscribe();
        this.aggregatedEventsSubscription = this.gateway.subscribeForEvents(this.aggregatedEventsQuery);
    }
    subscribeForRegularEvents() {
        this.eventsSubscription && this.eventsSubscription.unsubscribe();
        this.eventsSubscription = this.gateway.subscribeForEvents(this.eventsQuery);
    }
    unsubscribe() {
        this.aggregatedEventsSubscription && this.aggregatedEventsSubscription.unsubscribe();
        this.eventsSubscription && this.eventsSubscription.unsubscribe();
    }
    updateEventsQuery(payload) {
        // we have only 1 event in our query and it should come in add only in the initial load
        this.eventsQuery.query = createEventsQueryString(payload.events[0].metadata.aggregatedEventIds);
        this.eventsQuery.locale = this.langCode;
        this.eventsQuery.initialData = "true";
    }
    updateEventsIds(payload) {
        let eventIds = payload.events[0].metadata.aggregatedEventIds.split(";");
        this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.ids.update, { ids: eventIds });
    }
    updateAggregatedEvents(response) {
        if (response.data && Object.keys(response.data).length > 0) {
            Object.keys(response.data).forEach((payload) => {
                response.data[payload].events.length > 0 && (this.aggregatedEvents = this[`${payload}`](response.data[payload], this.aggregatedEvents));
            });
            if (response.data.add.events.length > 0) {
                this.updateEventsQuery(response.data.add);
                this.updateEventsIds(response.data.add);
                this.subscribeForRegularEvents();
            }
            ;
        }
        else {
            this.subscribeForAggregatedEvents();
        }
    }
    updateEvents(response) {
        if (response.data) {
            Object.keys(response.data).forEach((payload) => {
                response.data[payload].events.length > 0 && (this.events = this[`${payload}`](response.data[payload], this.events));
            });
            response.data.add
                && response.data.add.events.length > 0
                && this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.participants.update, { participants: generateParticipantMapping(response.data.add.events) });
        }
        else {
            this.subscribeForAggregatedEvents();
        }
    }
    add(payload, events) {
        let evs = events.slice();
        payload.events.forEach((newEvent) => {
            let index = evs.findIndex((event) => event.id === newEvent.id);
            index > -1 ? (evs[index] = deepMerge(evs[index], newEvent)) : evs.push(newEvent);
        });
        return evs;
    }
    change(payload, events) {
        let evs = events.slice();
        payload.events.forEach((newEvent) => {
            let index = evs.findIndex((event) => event.id === newEvent.id);
            index > -1 && (evs[index] = deepMerge(evs[index], newEvent));
        });
        return evs;
    }
    /* istanbul ignore next */
    //@action.bound
    remove(payload, events) {
        //This method is ignored because as i've discussed with product and on remove we don't do anything, just display latest scores - vasil.t
        //If we need to remove events uncomment the implementation
        /*let evs = events.slice();

        payload.events.forEach((eventId) => {
            let index = evs.findIndex((event) => event.id === eventId);
            index > -1 && evs.splice(index, 1);
        });
        return evs;
        */
        return events;
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], AggregatedEventsRetriever.prototype, "aggregatedEvents", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AggregatedEventsRetriever.prototype, "events", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], AggregatedEventsRetriever.prototype, "currentSelectedTimeZone", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatedEventsRetriever.prototype, "setTimeZone", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatedEventsRetriever.prototype, "updateTimeZone", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatedEventsRetriever.prototype, "updateAggregatedEvents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatedEventsRetriever.prototype, "updateEvents", null);
//# sourceMappingURL=AggregatedEventsRetriever.js.map